@if (moduleFunctionsResource.isLoading()) {
  <app-loading />
} @else {
  <div class="flex flex-col space-y-3">
    @for (officeModule of officeSystemRecording().officeModule; track officeModule.officeId) {
      <app-office-system-accordion
        [moduleFunctions]="moduleFunctionsResource.value()!"
        [officeModule]="officeModule"
        [isFirst]="$first"
      />
    }
  </div>
}
